// extracted by mini-css-extract-plugin
export default {"infoCardsWrapper":"infoCardsWrapper--WTVhQ","wrap":"wrap--b9fIn","content":"content--lcD_z","blueAction":"blueAction--aRpqV","attachmentsWrapper":"attachmentsWrapper--est2c"};